export class ModalDialogConfiguration {
  header: string;
  headerText: string;
  isCrossClose = true;
  isBody = true;
  isFooter = true;
  footer: string;
  isYes = false;
  yesLabel = 'Yes';
  isNo = false;
  noLabel = 'No';
  isClose = true;
  closeLabel = 'Close';
  isCustom = false;
  customText: string;
  customLabel: string;
  customAction: string;
  buttonText: string;

  public constructor(init?: Partial<ModalDialogConfiguration>) {
    Object.assign(this, init);
  }
}
